import api from '../../services/api';

export const partnershipsApi = {
  getAvailablePartnerships: async () => {
    const { data } = await api.get('upsellings/partnerships/availables/');
    return data;
  },

  getPartnerships: async (adminId, params) => {
    const { data } = await api.get(`upsellings/partnerships/list/${adminId}/`, { params });
    return data;
  },

  /**
   * Every alliance of the platform, as origin → destination. Staff only;
   * anybody else gets a 403.
   */
  getStaffPartnerships: async (params) => {
    const { data } = await api.get('upsellings/staff/partnerships/', { params });
    return data;
  },

  createPartnership: async (partnershipData) => {
    const { data } = await api.post('upsellings/partnerships/create/', partnershipData);
    return data;
  },

  // The trailing slash matters: the route is declared with one, and the 301
  // that APPEND_SLASH answers does not survive a DELETE cleanly.
  deletePartnership: async (partnershipId) => {
    const { data } = await api.delete(`upsellings/partnerships/delete/${partnershipId}/`);
    return data;
  },
};
